import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Text from '../../../components/Text/Text';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
import routes from '../../../router/routes';
import forgotPassword, { clearForgotPassword } from '../../../thunks/auth/forgotPassword';
import alertType from '../../../common/alertType';
import Alert from '../../../components/Alert/Alert';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [userName, setUserName] = useState('');
  const {
    forgotPasswordData: {
      data: forgotResult,
      loading,
      error
    }
  } = useSelector((state) => ({
    forgotPasswordData: state.forgotPassword
  }), shallowEqual);

  useEffect(() => {
    dispatch(clearForgotPassword());
  }, []);

  const onSubmit = () => dispatch(forgotPassword({
    username: userName
  }));

  return (
    <div className="bg-background-light min-h-screen flex justify-center items-center">
      <div className="w-full max-w-[450px] text-center p-[40px] rounded-[10px] shadowDefault">
        <Text
          text="Reset Password?"
          bold
          styleContainer="justify-center"
          textStyle="text-[20px]"
        />
        <Text
          muted
          text="Enter the username or email address you used to create your MM account.
          We'll send you an email with instructions on how to reset your password."
          styleContainer="justify-center"
        />
        <div className="mb-[65px]" />
        <div>
          <Input
            type="text"
            name="email"
            value={userName}
            placeholder="username or email"
            onChange={({ target: { value } }) => setUserName(value)}
          />
          <div className="flex flex-row justify-end">
            <a
              href={routes.LOGIN}
              className="text-[14px] font-semibold text-primary no-underline hover:text-primary-hover"
            >
              Sign in
            </a>
          </div>
          <div className="flex flex-row justify-center">
            <Button
              text="Reset"
              disabled={userName.length < 3 && loading}
              onClick={onSubmit}
            />
          </div>
          <br />
          {(forgotResult || error) && !loading && (
            <Alert
              text={forgotResult?.message || error}
              type={forgotResult?.status === 'ok' ? alertType.info : alertType.warning}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
